import React from "react";
import Svg from "../images/Our Service.svg";
import classes from "../components/Services.module.css";

export default function Services() {
  return (
    <>
      <div className={classes["responsive-container"]}></div>
    </>
  );
}
